import { CheckCircle2Icon, ChevronsUpIcon } from "lucide-react";
import type { ReactNode } from "react";

import { CommandGroup, CommandItem } from "@/components/ui/command";
import { Text } from "@/components/ui/text";
import { useAccessionCommands } from "../AccessionCommands";

export const priorities: {
  priority: "STAT" | "ROUTINE";
  label: string;
  icon: ReactNode;
}[] = [
  { priority: "STAT", label: "STAT", icon: <ChevronsUpIcon /> },
  { priority: "ROUTINE", label: "Routine", icon: <CheckCircle2Icon /> },
];

export function SetPriorityCommands() {
  const { setPriority } = useAccessionCommands();

  return (
    <CommandGroup heading="Set accession priority">
      {priorities.map(({ priority, label, icon }) => (
        <CommandItem key={priority} onSelect={() => setPriority(priority)}>
          {icon}
          <Text>{label}</Text>
        </CommandItem>
      ))}
    </CommandGroup>
  );
}
